/* eslint-disable indent */
import React from "react";

import isEqual from "lodash/isEqual";
import moment from "moment/min/moment-with-locales.min";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locals/constants";
import "./styles.scss";

const ListNbrFacture = ({
  data,
  checkedItem,
  setCheckedItem,
  options,
  onClick,
}) => {
  const { t } = useTranslation(NAME_SPACES.COMPONENTS, {
    keyPrefix: "LIST_NBR_INVOICE",
  });
  return (
    <div
      className={`${
        isEqual(checkedItem, data)
          ? "product--select--card"
          : "product--fact--card"
      }`}
      onClick={() => {
        setCheckedItem(data);
        onClick(data);
      }}>
      <div className={"product--fact--card--wrap"}>
        <h2 className={"text--16"}>
          {t("RECIEPT_NUM", { receiptNo: data.receiptNo })}
        </h2>
        <p className={"text--10"}>
          {`${
            data.contractNo
              ? t("INVOICE_NUM", { contractNo: data.contractNo })
              : ""
          } ${
            data.creationDate
              ? t("DATE", {
                  creationDate: moment(data.creationDate).format("DD.MM.YY"),
                })
              : ""
          }`}
        </p>
      </div>
      {isEqual(checkedItem, data) && (
        <div className={"product--select--card--list"}>
          <>{options}</>
        </div>
      )}
    </div>
  );
};

ListNbrFacture.propTypes = {
  data: PropTypes.shape({
    contractNo: PropTypes.string,
    creationDate: PropTypes.string,
    receiptNo: PropTypes.string,
  }),
  checkedItem: PropTypes.shape({
    contractNo: PropTypes.string,
    creationDate: PropTypes.string,
    receiptNo: PropTypes.string,
  }),
  onClick: PropTypes.func,
  options: PropTypes.node,
  setCheckedItem: PropTypes.func,
};

ListNbrFacture.defaultProps = {
  data: [],
  onClick: () => {},
};

export default ListNbrFacture;
